{
	"ariaStartCulling": "Start Culling",
	"ariaStartEditing": "Start Editing",
	"batchEditDescription": "Batch edit with an AI Style or edit manually from scratch.",
	"cull": "Cull",
	"edit": "Edit",
	"editManually": "Edit manually",
	"selectBestShots": "Select your best shots with AI grouping, rating, and face detection.",
	"selectEditMode": "Select an Edit Mode",
	"startCulling": "Start Culling",
	"startEditing": "Start Editing",
	"useAiStyle": "Use AI Style"
}
